module.exports = __webpack_public_path__ + "img/edge_hebergements_ferme.73fd0445.svg";